import { render } from "./OrderViewTable.vue?vue&type=template&id=1cc7495b&scoped=true"
import script from "./OrderViewTable.vue?vue&type=script&lang=js"
export * from "./OrderViewTable.vue?vue&type=script&lang=js"

import "./OrderViewTable.vue?vue&type=style&index=0&id=1cc7495b&scoped=true&lang=scss"

import exportComponent from "/home/sergiugata/taptasty/-taptasty-order/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc7495b"]])

export default __exports__